// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"search-input-styles_searchInput__RnD-w","iconWrapper":"search-input-styles_iconWrapper__r1W5c","input":"search-input-styles_input__1FLrH"};